import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateAvailableCarts } from '../../store/ducks/tables/actions';
import { CartStatus } from '../../types/drawer.types';
import { Cart } from '../../store/ducks/freight/types';

export interface GetCartsReponse {
  page: number;
  rows: Cart[];
  totalRecords: number;
}

export default function useGetCarts() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    page: number;
    rowsPerPage?: number;
    freightId?: string;
    cartStatus?: CartStatus;
  }): Promise<GetCartsReponse | undefined> {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/carts', {
        params: {
          rowsPerPage: params.rowsPerPage || 20,
          page: params.page,
          freightId: params.freightId,
          cartStatus: params.cartStatus,
        },
      });

      if (response.status === 200) {
        dispatch(populateAvailableCarts(response.data));
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
